import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-carousel',
    // standalone: true, 
    // imports: [CommonModule], 
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.css'],
    standalone: false
})
export class CarouselComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}